export default __webpack_public_path__ + "static/media/landscape1-MASK-tile.be6972c1.png";